import { render, staticRenderFns } from "./collapseHeader.vue?vue&type=template&id=05f77978&scoped=true"
import script from "./collapseHeader.vue?vue&type=script&lang=js"
export * from "./collapseHeader.vue?vue&type=script&lang=js"
import style0 from "./collapseHeader.vue?vue&type=style&index=0&id=05f77978&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f77978",
  null
  
)

export default component.exports